import "react";
import o from "../../../../_virtual/index.js";
import c from "../../../@emotion/cache/dist/emotion-cache.browser.esm.js";
import { jsx as n } from "react/jsx-runtime";
import { C as p } from "../../../@emotion/react/dist/emotion-element-f0de968e.browser.esm.js";
let e;
typeof document == "object" && (e = c({
  key: "css",
  prepend: !0
}));
function d(t) {
  const {
    injectFirst: i,
    children: r
  } = t;
  return i && e ? /* @__PURE__ */ n(p, {
    value: e,
    children: r
  }) : r;
}
process.env.NODE_ENV !== "production" && (d.propTypes = {
  /**
   * Your component tree.
   */
  children: o.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: o.bool
});
export {
  d as default
};
